import {
  EDITOR_MODE_DEFAULT,
  EDITOR_MODE_ORG_TEMPLATE_MANAGER,
  EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
} from '~config/editorConstants';
import { saveEditorCanvas } from '~src/api';
import { notify } from '~src/notifications';
import { modifyState, getState } from '~src/state';
import { saveEditorTemplate } from '~src/templates';

export const saveEditorState = async (
  showAnimation = false,
  showNotification = false,
  saveAttempt = 1,
  maxAttempts = 3
) => {
  // Una cancellazione di pagina sta riscrivendo l'elenco delle pagine:
  // salvarlo adesso riassegnerebbe gli objectId alle pagine sbagliate.
  // L'autosave ci riproverà al giro successivo.
  if (getState('deletingPage')) {
    return;
  }

  modifyState('saving', true);

  if (showAnimation) {
    modifyState('savingWithAnimation', true);
  }

  const editorMode = getState('editorMode');

  if (
    [
      EDITOR_MODE_ORG_TEMPLATE_MANAGER,
      EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
    ].includes(editorMode)
  ) {
    try {
      await saveEditorTemplate();
      modifyState('totalChangesSinceLastSave', 0);

      if (showNotification) {
        notify({
          type: 'success',
          title: 'Progetto salvato',
          text: 'Il progetto è stato salvato con successo!',
        });
      }
    } catch (error) {
      console.error(error);
      notify({
        type: 'error',
        title: 'Si è verificato un problema',
        text:
          'Non è stato possibile salvare il template. Si prega di riprovare.',
      });
    }
  } else if (editorMode === EDITOR_MODE_DEFAULT) {
    try {
      await saveEditorCanvas();
      modifyState('totalChangesSinceLastSave', 0);

      if (showNotification) {
        notify({
          type: 'success',
          title: 'Progetto salvato',
          text: 'Il progetto è stato salvato con successo!',
        });
      }
    } catch (error) {
      console.error(
        `Salvataggio fallito (tentativo ${saveAttempt} di ${maxAttempts})`,
        error
      );
      const nextAttempt = (saveAttempt += 1);
      if (saveAttempt <= maxAttempts) {
        console.log('Prossimo tentativo di salvataggio', {
          nextAttempt,
        });
        return saveEditorState(
          showAnimation,
          showNotification,
          nextAttempt,
          maxAttempts
        );
      } else {
        if (showNotification) {
          notify({
            type: 'error',
            title: 'Si è verificato un problema',
            text:
              'Non è stato possibile salvare il progetto. Si prega di riprovare.',
          });
        }
      }
    }
  }

  modifyState('saving', false);
  modifyState('savingWithAnimation', false);
};
